import { createContext } from "react";
import { DefaultSettings, ISettingsProps } from "../Models.ts";

/**
 * `seed`/`setSeed` are the worksheet identity (ADR 0009). Only MathFactsGenerator
 * supplies them; other providers of this context (flash cards, quiz) leave them
 * undefined and nothing there reads them.
 */
export const SettingsContext = createContext<{
    settings: ISettingsProps;
    setSettings: (settings: ISettingsProps) => void;
    seed?: string;
    setSeed?: (seed: string) => void;
}>({ settings: DefaultSettings, setSettings: (settings: ISettingsProps) => {} });
